const styleSheet = (theme: any) => ({
  body: {
    color: "#6373A4",
    fontSize: "14px",
    "& > div": {
      borderBottom: "1px solid #D8DCE6"
    },
    "& > div:last-child": {
      borderBottom: "none"
    },
    "& :first-child": {}
  }
});

export default styleSheet;
try {
    // @ts-ignore
    styles.displayName = "styles";
    // @ts-ignore
    styles.__docgenInfo = { "description": "", "displayName": "styles", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/hoc/Table/TableBody/styles.ts#styles"] = { docgenInfo: styles.__docgenInfo, name: "styles", path: "src/shared/hoc/Table/TableBody/styles.ts#styles" };
}
catch (__react_docgen_typescript_loader_error) { }